module.exports = __webpack_public_path__ + "img/glow-red.3f67506a.svg";